import { POLICY_ANSWER_NO_POLICY } from '../api/ester-b2b-api/private/certification/types'

export const shouldOfferPolicyDocumentUpload = (policyAnswer: string | undefined): boolean =>
  policyAnswer !== POLICY_ANSWER_NO_POLICY
